"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getBaseListAll", {
    enumerable: true,
    get: function() {
        return getBaseListAll;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function getBaseListAll(userId, ncMeta = _Noco.default.ncMeta) {
    const key = `${_globals.CacheScope.CMD_PALETTE}:baseListAll:${userId}`;
    let cached = await _NocoCache.default.get('root', key, _globals.CacheGetType.TYPE_OBJECT);
    if (!cached) {
        const rows = await ncMeta.knexConnection(`${_globals.MetaTable.PROJECT} as b`).select('b.id as base_id', 'b.title as base_title', 'b.meta as base_meta', 'bu.roles as base_role', 'b.order as base_order').innerJoin(`${_globals.MetaTable.PROJECT_USERS} as bu`, `b.id`, `bu.base_id`).where('bu.fk_user_id', userId).andWhereNot('bu.roles', _nocodbsdk.ProjectRoles.NO_ACCESS).andWhere(function() {
            this.where('b.deleted', false).orWhereNull('b.deleted');
        }).orderBy('b.order', 'asc');
        const bases = rows.map((row)=>{
            var _row_base_order;
            return {
                id: row.base_id,
                title: row.base_title,
                meta: (0, _modelUtils.parseMetaProp)(row, 'base_meta'),
                role: row.base_role,
                order: (_row_base_order = row.base_order) != null ? _row_base_order : 0
            };
        });
        cached = {
            workspaces: [
                {
                    id: 'nc',
                    title: 'NocoDB',
                    meta: {},
                    bases
                }
            ]
        };
        await _NocoCache.default.set('root', key, cached);
        // Append to the same lists command palette uses so cleanup piggybacks
        await _NocoCache.default.set('root', `${_globals.CacheScope.CMD_PALETTE}:ws`, [
            key
        ]);
        await _NocoCache.default.set('root', `${_globals.CacheScope.CMD_PALETTE}:user:${userId}`, [
            key
        ]);
    }
    return cached;
}
